'use es6';

import { SALES_SIGNUP } from '../constants/signupConstants';
import { gettingStartedLink } from '../utils/urls';
import { getViaRedirectionParam } from '../utils/redirectUtils';
import salesExperiences from './salesExperiences';
import marketingExperiences from './marketingExperiences';
import servicesExperiences from './servicesExperiences';
import suiteExperiences from './suiteExperiences';
import opsExperiences from './opsExperiences';
import trialExperiences from './trialExperiences';
import cmsExperiences from './cmsExperiences';
import { maybeGetSalesReplacementRedirectUrl, shouldNotSkipSetupUi } from './salesIntentLinkData';
export const gettingStartedRedirect = () => ({
  redirectPath: gettingStartedLink,
  redirectParams: {
    enroll: 'true'
  }
});
export const maybeGetReplacementRedirectUrl = (redirectUrl, {
  portalId,
  queryParams,
  signupIntent,
  signupType
}) => {
  switch (signupType) {
    case SALES_SIGNUP:
      return maybeGetSalesReplacementRedirectUrl({
        portalId,
        redirectUrl,
        queryParams,
        signupIntent
      });

    default:
      return redirectUrl;
  }
};
export const getDecorationParams = ({
  intentLink,
  signupIntent,
  signupType,
  survey,
  queryParams
}) => {
  return Object.assign({}, survey.crmExperience && {
    crmExperience: survey.crmExperience
  }, {}, signupType && {
    via: getViaRedirectionParam(signupType)
  }, {}, signupType === SALES_SIGNUP && Object.assign({}, shouldNotSkipSetupUi({
    redirectUrl: intentLink,
    queryParams,
    signupIntent
  }) && {
    redirect: intentLink
  }));
};
export const onboardingRedirectChecks = [...salesExperiences, ...suiteExperiences, ...marketingExperiences, ...servicesExperiences, ...opsExperiences, ...trialExperiences, ...cmsExperiences];